import { buildExperienceDetailPath } from '@/wabunka-src/common/features/Experience/utils/experienceDetailPath';

/**
 * TOP の「Japan Through Film」動画セクションに並べる動画リスト（JCAT-5830）。
 *
 * 動画の追加・差し替え・CTA 用パスの設定は、このファイルの編集だけで完結する。
 * CMS 化はしない（更新頻度は 2〜4 週に 1 回・PR 運用）。
 */
export interface JourneyVideo {
  /** YouTube の動画 ID（11 文字）。URL 全体ではない */
  videoId: string;
  /**
   * 動画の名前。**画面には表示しない**（タイトルはサムネイル画像に焼き込まれているため）。
   * 用途は 2 つ:
   *   1. YouTubeFacade へ渡して oEmbed へのリクエストを止める（title が falsy だと facade が取得しに行く）
   *   2. 再生ボタンの aria-label（`Play video: <title>`）になる
   */
  title: string;
  /**
   * CTA「Experience it firsthand」の遷移先。自サイト内のパスのみ。
   * 未設定の動画では CTA を表示しない。
   */
  ctaPath?: string;
}

export const JOURNEY_THROUGH_JAPAN_VIDEOS: readonly JourneyVideo[] = [
  {
    videoId: 'yVo4iymJcDo',
    title: '110 Years of Traditional Japanese Woodworking in Tokyo',
    ctaPath: buildExperienceDetailPath('en_mogami-kogei'),
  },
  {
    videoId: 'IvrOCsr0nKc',
    title: 'What Is It Like to Stay at a 150-Year-Old Masterpiece Ryokan? | Ochiairo, Izu',
    ctaPath: buildExperienceDetailPath('en_ochiairo'),
  },
  {
    videoId: 'NyLPhW1594o',
    title: 'Undiscovered Japan − Where City Fades into Nature ｜Kamakura・Hakone',
    ctaPath: '/hakone/',
  },
  {
    videoId: 'kdBDQhVvxfM',
    title: 'Japanese Swordsmith Documentary: Forging a Knife with Katana Techniques',
    ctaPath: buildExperienceDetailPath('en_hirata-kitchenknife'),
  },
  {
    videoId: 'FdmBgl5DmTA',
    title: 'How a Japanese Seal "Hanko" is Made: The Philosophy Behind Craftsmanship',
    ctaPath: buildExperienceDetailPath('en_kamakurahanko-basic'),
  },
];
